import { render, staticRenderFns } from "./BillingAccount.vue?vue&type=template&id=468d7b18"
import script from "./BillingAccount.vue?vue&type=script&lang=js"
export * from "./BillingAccount.vue?vue&type=script&lang=js"
import style0 from "./BillingAccount.vue?vue&type=style&index=0&id=468d7b18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports